import classNames from 'classnames';
import ConfirmationDialog from 'components/foundation/dialogs/ConfirmationDialog/ConfirmationDialog';
import useLegacyNavigation from 'hooks/navigation/useLegacyNavigation';
import { t } from 'utils/localize';

export interface IProFeatureDialogProps {
  className?: string | object;
  isOpen: boolean;
  onClose: () => void;
  customMessage?: string;
}

const ProFeatureDialog = (props: IProFeatureDialogProps) => {
  const { className, isOpen, onClose } = props;

  const classes = classNames('pro-feature-dialog', className);
  const legacyNavigation = useLegacyNavigation();

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      title={t('Pro Feature')}
      message={
        props.customMessage
          ? props.customMessage
          : t('Upgrade to Pro to get access to advanced features that will help you grow your business.')
      }
      closeButtonText={t('Close')}
      confirmButtonText={t('Upgrade')}
      onConfirm={legacyNavigation.subscription}
      onClose={onClose}
      className={classes}
    />
  );
};

export default ProFeatureDialog;
